import { FC } from 'react'
import { PlatformDataType } from 'src/interfaces/Platform.interface'
import {
  getConnectedPlatformCountryCode,
  getConnectedPlatformLabel,
} from '../utils/connectedPlatformLabel'
import ListingProfilePlatformLogo from './ListingProfilePlatformLogo'

interface ListingProfileToolbarChannelBadgeProps {
  platform: PlatformDataType | null
}

const ListingProfileToolbarChannelBadge: FC<ListingProfileToolbarChannelBadgeProps> = ({
  platform,
}) => {
  if (!platform) return <span className="text-muted">Channel</span>

  const label = getConnectedPlatformLabel(platform)
  const countryCode = getConnectedPlatformCountryCode(platform)

  return (
    <span className="product-listing__toolbar-channel-badge">
      <ListingProfilePlatformLogo platform={platform} />
      <span className="product-listing__toolbar-channel-badge-copy">
        {countryCode ? (
          <span className="product-listing__toolbar-channel-badge-country">{countryCode}</span>
        ) : null}
        <span className="product-listing__toolbar-channel-badge-name">{label}</span>
      </span>
    </span>
  )
}

export default ListingProfileToolbarChannelBadge
